import { LazyLoad } from 'features/common/ui/LazyLoad'
import { FeatureFlag } from 'app/ui/useFeatureFlag'
import RequireFeatureFlag from 'app/ui/RequireFeatureFlag'
import AdvancedRoutes from './AccountAdvanced/AccountAdvancedRoutes'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { lazy } from 'app/lazy'

const AccountGeneral = lazy(() => import('./AccountGeneral/AccountGeneral'))
const AccountUsage = lazy(() => import('./AccountUsage/AccountUsage'))
const AccountAppsList = lazy(() => import('./AccountAdvanced/AccountAppsList/AccountAppsList'))
const AccountCustomization = lazy(() => import('./AccountCustomization/AccountCustomization'))
const AccountUsers = lazy(() => import('./AccountUsers/AccountUsers'))
const AccountPage = lazy(() => import('./AccountPage'))
const AccountAnalytics = lazy(() => import('./AccountAnalytics/AccountAnalytics'))
const SelectDataWarehousePage = lazy(() => import('./AccountAnalytics/NewInstallation/SelectDataWarehousePage'))
const ConnectWarehouseFormPage = lazy(() => import('./AccountAnalytics/NewInstallation/ConnectWarehouseFormPage'))
const ChangeCredentialsFormPage = lazy(() => import('./AccountAnalytics/ChangeCredentialsFormPage'))
const AccountAssetManagement = lazy(() => import('./AccountAssetManagement/AccountAssetManagement'))
const AccountDataObservatory = lazy(() => import('./AccountDataObservatory/AccountDataObservatory'))

export const SETTING_PATH = '/settings'
export enum SettingSection {
  General = '',
  Usage = 'usage',
  Apps = 'apps',
  Users = 'users',
  Customizations = 'customizations',
  Advanced = 'advanced',
  AnalyticsToolbox = 'analytics-toolbox',
  AssetManagement = 'asset-management',
  DataObservatory = 'data-observatory'
}

const routes = {
  path: 'settings',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<AccountPage />} />
    </LazyLoad>
  ),
  children: [
    {
      path: SettingSection.General,
      element: (
        <LazyLoad>
          <AccountGeneral />
        </LazyLoad>
      )
    },
    {
      path: SettingSection.Usage,
      element: (
        <LazyLoad>
          <AccountUsage />
        </LazyLoad>
      )
    },
    {
      path: SettingSection.Apps,
      element: (
        <LazyLoad>
          <AccountAppsList />
        </LazyLoad>
      )
    },
    {
      path: SettingSection.Users,
      element: (
        <LazyLoad>
          <AccountUsers />
        </LazyLoad>
      )
    },
    {
      path: SettingSection.Customizations,
      element: (
        <LazyLoad>
          <AccountCustomization />
        </LazyLoad>
      )
    },
    ...AdvancedRoutes,
    {
      path: SettingSection.AnalyticsToolbox,
      element: (
        <RequireFeatureFlag flag={FeatureFlag.AtInstallation}>
          <LazyLoad>
            <AccountAnalytics />
          </LazyLoad>
        </RequireFeatureFlag>
      )
    },
    {
      path: `new-analytics-toolbox/select-warehouse`,
      element: (
        <RequireFeatureFlag flag={FeatureFlag.AtInstallation}>
          <SelectDataWarehousePage />
        </RequireFeatureFlag>
      )
    },
    {
      path: `new-analytics-toolbox/connect-warehouse/:id`,
      element: (
        <RequireFeatureFlag flag={FeatureFlag.AtInstallation}>
          <LazyLoad>
            <ConnectWarehouseFormPage />
          </LazyLoad>
        </RequireFeatureFlag>
      )
    },
    {
      path: `update-analytics-toolbox-config/:id`,
      element: (
        <RequireFeatureFlag flag={FeatureFlag.AtInstallation}>
          <LazyLoad>
            <ChangeCredentialsFormPage />
          </LazyLoad>
        </RequireFeatureFlag>
      )
    },
    {
      path: SettingSection.AssetManagement,
      element: (
        <RequireFeatureFlag flag={FeatureFlag.SuperadminMode}>
          <LazyLoad>
            <AccountAssetManagement />
          </LazyLoad>
        </RequireFeatureFlag>
      )
    },
    {
      path: SettingSection.DataObservatory,
      element: (
        <RequireFeatureFlag flag={FeatureFlag.ListDoSubscriptions}>
          <LazyLoad>
            <AccountDataObservatory />
          </LazyLoad>
        </RequireFeatureFlag>
      )
    }
  ]
}

export default routes
